<template>
  <div class="radio">
    <el-radio-group
      v-model="value"
      @change="change"
    >
      <el-radio
        v-for="option in question.optionList"
        :key="option"
        :label="option"
      >
      </el-radio>
    </el-radio-group>

  </div>
</template>

<script>
import mixins from "./mixins";

export default {
  name: "radio",
  mixins: [mixins],
  data() {
    return {
      value: "",
    };
  },
  watch: {
    question: {
      handler(newVal) {
        if (newVal.answer !== this.value) {
          this.value = newVal.answer;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>